import styled, { css } from "styled-components";

export const SecondaryTextBase = styled.div`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 400;
    color: ${theme?.colour?.secondary ?? '#04333B'};
  `}
`;